import React, { useMemo, useRef, useState, useEffect } from 'react';
import UploadFiles from '../UploadFiles'
import { useDispatch, useSelector } from 'react-redux';
import LineChartPreview from '../LineChartPreview'
import Modal from '../../reusables/Modal';
import { MdOutlineChevronRight } from "react-icons/md";
import { setQcFilesData } from '../../reduxSlices/results/resultsSlice';
import { useNavigate } from 'react-router-dom';
import { logUserEvent } from '../../lib/utilities/logUserEvent';
import BackButton from '../shared/BackButton';
import ConfirmationModal from '../shared/ConfirmationModal';
import { useConfigNavigationGuard } from '../../hooks/useConfigNavigationGuard';
import { resetAll } from '../../reduxSlices/results/resultsSlice';
// import saveResultsToFirebase from '../../lib/utilities/saveResultsToFirebase';
// import  sanitizeKeyDeep  from '../../lib/utilities/sanitizeKeyDeep';


function UploadQcFiles() {
    const [files, setFiles] = useState([]);
    const [fileName, setFileName] = useState('');
    const [open, setOpen] = useState(false);
    const [chartPreviewData, setChartPreviewData] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const qcFilesObj = useSelector(store => store.results.qcFiles);
    const configId = localStorage.getItem('currentConfigId');
    // const results = useSelector(state => state.results);
    const seededRef = useRef(false);

    // Navigation guard
    const { showExitModal, handleConfirmExit, handleCancelExit } = useConfigNavigationGuard(
        ['/configuration/uploadUnkFiles', '/configuration/uploadStdFiles'],
        () => dispatch(resetAll())
    );

    const qcFilesList = useMemo(() => {
        if (!qcFilesObj) return [];
        // Preserve object insertion order
        return Object.keys(qcFilesObj).map(name => qcFilesObj[name]);
    }, [qcFilesObj]);

    useEffect(() => {
        if (!seededRef.current && qcFilesList.length > 0) {
            setFiles(qcFilesList);
            seededRef.current = true;
        }
    }, [qcFilesList]);

    const handleFileInput = (finalFiles) => {
        setFiles(finalFiles);
        // Store files locally, Redux action will happen when Next button is clicked
    }

    const getOriginalDataByName = (nameToFind) => {
        const source = files.length > 0 ? files : qcFilesList;
        const foundObject = source.find(item => (item.fileName || item.name) === nameToFind);
        return foundObject ? (foundObject.fileData?.originalData || foundObject.originalData) : [];
    };

    const handleFileName = (fileName) => {
        setOpen(true);
        setFileName(fileName)
        setChartPreviewData(getOriginalDataByName(fileName))
    }


    const handleNextScreen = async () => {
        const effectiveFiles = files.length > 0 ? files : qcFilesList;

        // Check if files have actually changed by comparing with Redux state
        const hasChanges = !areFilesEqual(effectiveFiles, qcFilesList);

        if (hasChanges) {
            dispatch(setQcFilesData(effectiveFiles));
            logUserEvent("upload_qc_files", {
                fileCount: effectiveFiles.length,
                fileNames: effectiveFiles.map(file => file.fileName || file.name),
            });
        }

        // Save to Firebase removed. Only update Redux here.
        //     });
        // } catch (err) {
        //     console.error('Error saving QC files to Firebase:', err);
        // }

        navigate('/configuration/uploadUnkFiles')
    }

    // Helper function to compare file arrays
    const areFilesEqual = (currentFiles, reduxFiles) => {
        if (currentFiles.length !== reduxFiles.length) return false;

        // Compare file names and basic properties
        for (let i = 0; i < currentFiles.length; i++) {
            if (currentFiles[i].name !== (reduxFiles[i].fileName || reduxFiles[i].name)) return false;
            // Could add more detailed comparison if needed
        }

        return true;
    }
    return (
        <>
            <ConfirmationModal
                isOpen={showExitModal}
                onClose={handleCancelExit}
                onConfirm={handleConfirmExit}
                title="Leave Configuration?"
                message="If you leave now, the current configuration will not be saved and all progress will be lost. Are you sure you want to continue?"
                confirmText="Leave"
                cancelText="Stay"
                type="warning"
            />
            <div className='flex flex-col px-4 items-center justify-center mt-6'>
                <h2 className='text-lg  mb-8 self-start'>Upload your <span className='font-bold  text-customeOrange'>Quality Control</span> Files by drag and drop or click in the box below.</h2>

            </div>
            <UploadFiles
                initialFiles={files.length > 0 ? files : qcFilesList}
                moreColors={false}
                showHelpText={false}
                handleFileInput={handleFileInput}
                fileType={'qualityControl'}
                handleFileName={handleFileName}
            />
            <div className='fixed bottom-8 right-8 z-40 flex gap-2'>
                <BackButton to={'/configuration/uploadStdFiles'} />
                {/* <div className='flex items-center justify-center'>
                <IoMdArrowBack />
                <button 
                    // onClick={onBack} 
                    className='text-lg text-indigo-700 ml-2'>Prev</button>
            </div> */}
                <button
                    disabled={(files.length === 0 && qcFilesList.length === 0)}
                    onClick={() => handleNextScreen()}
                    className={`flex-row flex items-center justify-center bg-buttonColorActive text-white font-semibold w-32 p-3 rounded-md self-center disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed hover:bg-customeOrange hover:text-customeBlack`}
                >Next
                    <MdOutlineChevronRight className='ml-6' fontSize={24} />
                </button>
            </div>

            <Modal open={open} onClose={() => setOpen(false)}>
                <LineChartPreview data={chartPreviewData} fileName={fileName} />
            </Modal>
        </>
    )
}

export default UploadQcFiles